export const languages = {
  en: 'English',
  fr: 'French',
  es: 'Spanish',
  zh: 'Chinese',
  ja: 'Japanese',
  ar: 'Arabic'
};